import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { signInApi } from "../../api/api";
import { NormalInput, PassWordInput } from "../Common/Input";
import CustomSpinner from "../Common/CustomSpinner";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/reducers/userSlice";

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const [error, setError] = useState({ text: "", error: false });
  const [loading, setLoading] = useState(false);
  const [eye, setEye] = useState(false);
  const [email, setEmail] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const redirectUrl = "/assessment-history";

  const onSubmit = async (data) => {
    setEmail(data.email);
    setLoading(true);
    setError({ text: "", error: false });
    const bodyData = {
      email: data.email,
      password: data.password,
    };
    const res = await signInApi(bodyData);
    if (res?.doctor) {
      localStorage.setItem("doctor", JSON.stringify(res.doctor));
      dispatch(setUser(res.doctor));
    }
    if (res?.token) {
      localStorage.setItem("token", res.token);
      // navigate(redirectUrl);
      window.location.href = redirectUrl;
    }
    setLoading(false);
  };

  return (
    <div style={{ width: "50%" }} className="mx-auto">
      <div className=" md:grid gap-7 spac-y-4">
        <div>
          <div className="py-7">
            <h2 className="text-[36px] font-semibold">Welcome Back</h2>
            <p className="text-[18px] font-[500]">
              We are Happy to see you again. let's get started
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4 mt-4">
              <NormalInput
                name={"email"}
                placeholder="Type Your Email"
                required={true}
                styles="py-4 appearance-none block"
                register={register}
                validationSchema={{
                  required: "Email is required",
                }}
                errors={errors}
              />
            </div>
            <div className="mb-4 mt-4">
              <PassWordInput
                name={"password"}
                placeholder="Type Your Password"
                type="password"
                required={true}
                styles="py-4 appearance-none block"
                register={register}
                validationSchema={{
                  required: "Password is required",
                  minLength: {
                    value: 6,
                    message: "Password must have at least 6 characters",
                  },
                }}
                eye={eye}
                setEye={() => setEye(!eye)}
                errors={errors}
              />
            </div>

            <div
              className={`${
                error?.error ? "mb-[12px]" : "mb-[24px]"
              } flex justify-end`}
            >
              <p className="text-[#3c7fff] underline underline-offset-1">
                Forget Password
              </p>
            </div>
            <div className="mb-[12px]">
              <p className="text-red-500 text-[18px]">
                {error.error && error.text}
              </p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <button
                className="py-3 w-full bg-[#3c7fff] hover:bg-indigo-800 font-bold px- rounded text-white flex justify-center"
                type="submit"
                disabled={loading}
              >
                {loading ? <CustomSpinner /> : " Log in"}
              </button>
            </div>
          </form>
          <div className="mt-3 text-center">
            <p>
              Don't have an account?{" "}
              <span
                className="text-[#3c7fff] underline underline-offset-1 cursor-pointer"
                onClick={() => navigate("/signup")}
              >
                Sign up
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
